module.exports = __webpack_public_path__ + "static/00000000-0000-0000-0000-000000000000-700.2a828f54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/test-tableware/00000000-0000-0000-0000-000000000000-700.jpg
// module id = 1257
// module chunks = 168707334958949